import * as React from "react";
import { Form } from "semantic-ui-react";

export type IndicatorFieldProps = {
  id: string;
  label?: string;
  text: string;
  isWarning: boolean;
};

function TextIndicatorField({ id, label, text, isWarning }: IndicatorFieldProps):JSX.Element {
  const warningColor = "#ffa500";
  return (
    <Form.Field className="edit-indicator-property">
      <label>{label}</label>
      <div id={id} style={isWarning ? { color: warningColor } : {}}>
        {(isWarning ? "*" : "") + text}
      </div>
    </Form.Field>
  );
}

export default TextIndicatorField;
